import { BaseResponse } from '@app/entities/BaseResponse';
import { apiRequest } from './apiUtils';
import { ApiError } from './ApiError';
import i18n from '@app/i18n';

const BASE_URL = 'NotificationRabbits';

export const getLatestNotificationsRabbit = async (): Promise<any[] | null> => {
  const areaCode = process.env.REACT_APP_CURRENT_LOCALITY;

  const res = await apiRequest<BaseResponse<any[]>>(
    'GET',
    `${BASE_URL}/latest/notification/all`,
    { params: { areaCode } }
  );

  if (!res?.result?.success) {
    throw new ApiError(res?.result?.message || i18n.t('serverError.main'));
  }

  return res.data || null;
};

export const markRabbitNotificationAsRead = (notificationId: number): Promise<boolean> =>
  apiRequest<BaseResponse<boolean>>('PUT', `${BASE_URL}/${notificationId}/mark-read`).then(res => res.data);

export const deleteNotificationRabbit = (notificationId: number): Promise<boolean> =>
  apiRequest<BaseResponse<boolean>>('DELETE', `${BASE_URL}/${notificationId}`).then(res => res.data);

export const getNotificationRabbitsByPage = (
  pageNumber: number,
  pageSize: number,
  canisterId: string,
  actionType: string
): Promise<BaseResponse<any>> =>
  apiRequest<BaseResponse<any>>('GET', `${BASE_URL}`, {
    params: {
      pageSize,
      pageNumber,
      areaCode: process.env.REACT_APP_CURRENT_LOCALITY,
      canisterId,
      actionType
    },
  });

export const GetSurveillanceRequestByCardProcessingId = (cardProcessingId: number): Promise<BaseResponse<any>> =>
  apiRequest<BaseResponse<any>>('GET', `${BASE_URL}/GetSurveillanceRequestByCardProcessingId`, {
    params: { cardProcessingId },
  });

export const GetCardOnOffByCardProcessingId = (cardProcessingId: number): Promise<BaseResponse<any>> =>
  apiRequest<BaseResponse<any>>('GET', `${BASE_URL}/GetCardOnOffByCardProcessingId`, {
    params: { cardProcessingId },
  });

export const GetCardDetailsByLosingShoeId = (losingShoeId: number): Promise<BaseResponse<any>> =>
  apiRequest<BaseResponse<any>>('GET', `${BASE_URL}/GetCardDetailsByLosingShoeId`, {
    params: { losingShoeId },
  });

export const GetUnhandledCardOff = (unhandledId: number): Promise<BaseResponse<any>> =>
  apiRequest<BaseResponse<any>>('GET', `${BASE_URL}/GetUnhandledCardOff`, {
    params: { unhandledId },
  });

export const GetMd3OnOffByCardProcessingId = (cardProcessingId: number): Promise<BaseResponse<any>> =>
  apiRequest<BaseResponse<any>>('GET', `${BASE_URL}/GetMd3OnOffByCardProcessingId`, {
    params: { cardProcessingId },
  });

export const GetTempOnOffByCardProcessingId = (cardProcessingId: number): Promise<BaseResponse<any>> =>
  apiRequest<BaseResponse<any>>('GET', `${BASE_URL}/GetTempOnOffByCardProcessingId`, {
    params: { cardProcessingId },
  });

export const getNonCardProcessingByBatchId = (batchId: string): Promise<BaseResponse<any>> =>
  apiRequest<BaseResponse<any>>('GET', `${BASE_URL}/getNonCardProcessingByBatchId`, {
    params: { batchId },
  });
export const getCardProcessingByBatchId = (batchId: string): Promise<BaseResponse<any>> =>
  apiRequest<BaseResponse<any>>('GET', `${BASE_URL}/getCardProcessingByBatchId`, {
    params: { batchId },
  });

export const getCardProcessingByActionId = (actionId: number): Promise<BaseResponse<any>> =>
  apiRequest<BaseResponse<any>>('GET', `${BASE_URL}/getCardProcessingByActionId`, {
    params: { actionId },
  });


export const getNonCardProcessingByActionId = (actionId: number): Promise<BaseResponse<any>> =>
  apiRequest<BaseResponse<any>>('GET', `${BASE_URL}/getNonCardProcessingByActionId`, {
    params: { actionId },
  });

